// apis/financial.js
import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

export const useGetTwilioCostQuery = (params, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_TWILIO_COST, params],
    queryFn: () => api.get(API_ROUTES.GET_TWILIO_COST, { params }),
    enabled,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useGetIntelliSmsCostQuery = (params, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_INTELLISMS_COST, params],
    queryFn: () => api.get(API_ROUTES.GET_INTELLISMS_COST, { params }),
    enabled,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useGetXeroCostsQuery = (params) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_XERO_COSTS, params],
    queryFn: () => api.get(API_ROUTES.GET_XERO_COSTS, { params }),
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useGetFinancialsQuery = (params, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_FINANCIALS, params],
    queryFn: () => api.get(API_ROUTES.GET_FINANCIALS, { params }),
    enabled,
  });
  return { data: data?.data ?? [], isPending, isError, error };
};

export const useGetPaymentsQuery = (params) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_PAYMENTS, params],
    queryFn: () => api.get(API_ROUTES.GET_PAYMENTS, { params }),
    placeholderData: (prev) => prev,
  });
  return { data: data?.data ?? null, isPending, isFetching, isError, error };
};

// Rebuilds the financials and payments on screen past the server's five-minute cache.
export const useRefreshFinancials = () => {
  const queryClient = useQueryClient();
  return useCallback(async () => {
    const queries = [API_ROUTES.GET_FINANCIALS, API_ROUTES.GET_PAYMENTS].flatMap(
      (route) =>
        queryClient.getQueryCache().findAll({ queryKey: [route], type: "active" }),
    );
    await Promise.all(
      queries.map(async ({ queryKey }) => {
        const [route, params] = queryKey;
        const response = await api.get(route, {
          params: { ...params, refresh: 1 },
        });
        queryClient.setQueryData(queryKey, response);
      }),
    );
  }, [queryClient]);
};
